<template>
<div class="softwareUpgrade">
  <div class="upgrade">
    <div class="upgradeRecord">
      <div class="upgradeRecordTit">升级记录</div>
    </div>
    <!-- 新增表单 -->
    <div class="upgradeBtn">
      <el-input placeholder="请输入名称(回车搜索)" suffix-icon="el-icon-search" v-model="search_name" clearable @keydown.enter.native="firmwareTable(search_page)" 
      style="width:200px" @change="firmwareTable(search_page)"></el-input>
      <el-select v-model="search_type" placeholder="请选择设备类型" style="" clearable filterable @change="firmwareTable(search_page)">
        <el-option
          v-for="item in firmwareTypes"
          :key="item.id"
          :label="item.value"
          :value="item.id">
        </el-option>
      </el-select>
      <el-input placeholder="请输入型号(回车搜索)" suffix-icon="el-icon-search" v-model="search_softwareType" clearable @keydown.enter.native="firmwareTable(search_page)" 
      style="width:200px; margin:0 20px"  @change="firmwareTable(search_page)"></el-input>
      <el-button class="upgrade_btn" @click="addRecord">新增</el-button>
      <el-dialog :title='dailogTitle' :visible.sync="dialogFormVisible" v-if="dialogFormVisible" :close-on-click-modal="false" class="add_dialog">
        <el-form :model="form" :label-width="formLabelWidth" ref="upgradeForm" :rules="formRules">
          <el-form-item label="名称：" prop="name">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="型号：" prop="softwareType">
            <el-input v-model="form.softwareType" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="版本：" prop="version">
            <el-input v-model.number="form.version" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="固件类型：" prop="type">
            <el-select v-model="form.type" placeholder="" style="width:100%" clearable filterable>
              <el-option
                v-for="item in firmwareTypes"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件校验方式：" prop="fileVerificationMode" class="check">
            <el-radio v-model="fileVerificationMode" label="1">MD5</el-radio>
            <el-radio v-model="fileVerificationMode" label="2">CRC</el-radio>
          </el-form-item>
          <el-form-item label="切割：" prop="cuttingFlag" class="check">
            <el-checkbox v-model="cuttingFlag" @change="changeCheckbox">是否选择文件切割</el-checkbox>
          </el-form-item>
          <el-form-item label="说明：" prop="memo">
            <el-input type="textarea" v-model="form.memo"></el-input>
          </el-form-item>
          <el-form-item label="文件：" prop="filePath" class="uploadFile">
              <!-- <el-input v-model="form.file" autocomplete="off"></el-input> -->
              <!-- <el-upload
                v-model="form.filePath"
                class="avatar_uploader"
                ref="upload"
                :action="add_uploadUrl"
                :data="add_upData"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :file-list="fileList"
                name="file"
                :limit="1"
                :auto-upload="autoUpload"
                :on-change="fileChange"
                :before-upload='beforeUpload'
                :on-success="upFile"
                :headers="header"
                :on-error="err_upFile"
                >
                <div class="el-upload__text"><i class="el-icon-upload avatar-uploader-icon"></i></div>
              </el-upload> -->
              <el-upload
                ref="upload"
                v-model="form.filePath"
                class="avatar_uploader"
                drag
                action="#"
                :limit="1"
                name="file"
                :file-list="fileList"
                :on-change="file_change"
                :before-upload='before_upload'
                :on-success="success_upFile"
                :http-request="handle_file_custom"
                :on-remove="handle_remove"
                :on-progress="upload_progress"
                list-type="text"
              >
                <i class="el-icon-upload" />
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                
              </el-upload>
              <!-- <el-progress style="width: 200px;margin-top: 8px"  :percentage="progressPercent" /> -->
          </el-form-item>
          
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" @click="cancelUploadBtn('upgradeForm')">取 消</el-button>
          <el-button type="primary" @click="confirmUploadBtn('upgradeForm')" :loading="loadingsubmit">{{confirmText}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
    
  <!-- 表格 -->
  <div class="table">
    <el-table :data="tableData" border style="width: 100%" v-loading="loading"
    element-loading-background = "rgba(255, 255, 255, .5)" element-loading-text = "加载中，请稍后..." element-loading-spinner = "el-icon-loading">
      <el-table-column prop="name" label="名称" min-width="160">
      </el-table-column>
      <el-table-column prop="typeName" label="设备类型" width="120">
      </el-table-column>
      <el-table-column prop="softwareType" label="型号" min-width="120">
      </el-table-column>
      <el-table-column prop="version" label="版本" width="100">
      </el-table-column>
      <el-table-column prop="memo" label="说明" min-width="200">
      </el-table-column>
      <el-table-column prop="createTime" label="时间" :formatter="timestampToTime" width="180">
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="{row}">
          <el-button type="text" size="small" @click="upgrade_firmware(row)" class="upgrade_btn1">升级</el-button>
          <el-divider direction="vertical" v-if="row.cuttingFlag !== 1"></el-divider>
          <el-button type="text" size="small" class="upgrade_btn1" v-if="row.cuttingFlag !== 1">
            <a :href="row.filePath">下载</a>
          </el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button @click="delRecord(row)" type="text" size="small" class="delete">删除</el-button> 
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div>
    <!-- 升级 -->
    <el-dialog :title='dailogTitle' :visible.sync="dialogFormVisible1" v-if="dialogFormVisible1" :close-on-click-modal="false">
      <el-form :model="form" :label-width="formLabelWidth" ref="upgradeForm" :rules="formRules">
        <el-form-item label="版本：" prop="version">
          <el-input v-model.number="form.version" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="固件类型：" prop="type">
            <el-input v-model="form.type" autocomplete="off"></el-input>
          </el-form-item> -->
        <el-form-item label="说明：" prop="memo">
          <el-input type="textarea" v-model="form.memo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="文件校验方式：" prop="fileVerificationMode" class="check">
            <el-radio v-model="fileVerificationMode" label="1">MD5</el-radio>
            <el-radio v-model="fileVerificationMode" label="2">CRC</el-radio>
          </el-form-item>
        <el-form-item label="文件：" prop="" class="uploadFile">
            <!-- <el-input v-model="form.file" autocomplete="off"></el-input> -->
            <!-- <el-upload
              v-model="form.filePath"
              class="avatar_uploader"
              ref="upgrade_upload"
              :action="upgrade_uploadUrl"
              :data="upgrade_upData"
              :on-preview="handlePreview1"
              :on-remove="handleRemove1"
              :file-list="fileList1"
              name="file"
              :auto-upload="autoUpload"
              :on-change="fileChange1"
              :before-upload='beforeUpload1'
              :on-success="upFile1"
              :headers="header"
              :on-error="err_upFile1"
              >
              <i class="el-icon-upload avatar-uploader-icon"></i>
          </el-upload> -->
            <!-- :auto-upload="false" //关闭自动上传 -->
            <!-- :data="editForm"   //表单数据作为上传时附带的额外参数 -->
            <!-- :on-success="upFile" //成功会执行此函数 -->
            <!-- accept=".doc,.docx,.xslx,pdf,.ppt" //限制上传文件的类型 -->
            <!-- action="http://" //上传文件的地址 -->
            <el-upload
                ref="upload"
                v-model="form.filePath"
                class="avatar_uploader"
                drag
                action="#"
                :limit="1"
                name="file"
                :file-list="fileList1"
                :on-change="file_change1"
                :before-upload='before_upload1'
                :on-success="success_upFile1"
                :http-request="handle_file_custom1"
                :on-remove="handle_remove1"
                :on-progress="upload_progress1"
              >
                <i class="el-icon-upload" />
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <el-progress style="width: 200px;margin-top: 8px"  :percentage="progressPercent" />
              </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelUploadBtn('upgradeForm')">取 消</el-button>
        <el-button type="primary" @click="confirmUploadBtn('upgradeForm')" :loading="loadingsubmit">{{confirmText}}</el-button>
      </div>
    </el-dialog>
  </div>

  <!-- 分页 -->
  <div class="pagination">
    <el-pagination
      background
      @size-change="changeSize"
      @current-change="changePage"
      :current-page="page.pageNum"
      :page-sizes="page_size_list"
      :page-size="page.pageSize"
      layout="prev, pager, next, sizes, total, jumper"
      :total="total">
    </el-pagination>
  </div>
</div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import {firmwareData,addFirmware,editFirmware,delFirmware} from "@/api"
//1.引入上传方法
import { upload_images_oss } from "@/utils/client"
import { get_sts } from '@/api'
  export default {
    data() {
      return {
        loading: false,
        loadingsubmit: false,
        confirmText: '确定',
        header: { token:localStorage.getItem("token") }, //请求头, 写在data里面
        dailogTitle: '',
        dialogFormVisible: false,
        dialogFormVisible1: false,
        add_uploadUrl: '',
        upgrade_uploadUrl: '',
        autoUpload: false,
        search_name: "",
        search_softwareType: "",
        form: {
          name: '',
          softwareType: '',
          file: null,
          version: '',
          memo: '',
          id: null,
          type: null,
          cuttingFlag: null,
          filePath: '', //文件路径规则：固件类型/固件版本/，例如：P3161A/9/）
          fileName: '',//文件名
          fileSize: '',//文件大小
          fileMd5: '',//文件md5
          fileVerificationMode:'1',
        },
        fileVerificationMode:'1',
        version: "",
        firmwareId: null,
        progressPercent:0,
        MD5: "",
        CRC32: "",
        firmwareTypes: [
          {
            id: 1,
            value: '网络类型'
          },
          {
            id: 2,
            value: '逻辑类型'
          },
          {
            id: 3,
            value: 'mesh类型'
          },
          {
            id: 4,
            value: '语音类型'
          },
        ],
        fileList: [],
        fileList1: [],
        cuttingFlag: false,
        formLabelWidth: '120px',
        formRules: {
          name:[
            { required: true, message: "请输入名称", trigger: "blur",},
            // {
            //   validator: function(rule, value, callback) {
            //     if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
            //       callback(new Error("只能输入2-30个包含中文、字母、数字、中划线、下划线的名称"));
            //     } else {
            //       //校验通过
            //       callback();
            //     }
            //   },
            //   trigger: "blur"
            // }
          ],
          softwareType:[
            { required: true, message: "请输入型号", trigger: "blur",},
            {
              validator: function(rule, value, callback) {
                if (/^[A-Za-z0-9-_()\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
                  callback(new Error("只能输入2-30个包含中文、字母、数字、中划线、下划线的型号"));
                } else {
                  //校验通过
                  callback();
                }
              },
              trigger: "blur"
            }
          ],
          version:[
            {required: true, message: "请输入版本且必须是数字类型", trigger: "blur",type: 'number',},
            // {
            //   validator: function(rule, value, callback) {
            //     if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,30}$/.test(value) == false) {
            //       callback(new Error("请输入正确的版本"));
            //     } else {
            //       //校验通过
            //       callback();
            //     }
            //   },
            //   trigger: "blur"
            // }
          ],
          type:[
            { required: true, message: "请选择固件类型", trigger: "change"}
          ]
          // fileList: 
          //   [{
          //     message: '请上传文件',
          //     trigger: 'change',
          //     required: true
          //   }],
        },
        tableData: [],//表格
        total: 0,
        add: false,
        upgrade: false,
        page: {
          pageSize: 10,
          pageNum: 1
        },
        search_page: {
          pageSize: 10,
          pageNum: 1
        },
        page_size_list: [10,20,30],
        fileUpload:false,
        fileUpload1:false,
        removeFile: false,
        removeFile1: false,
        loading1: null,
        loading2: null,
        directory_name: '',
        search_type: null,
        uploadLoading1:null,
        uploadLoading2:null,
      }
    },
    computed: {
    // 这里定义上传文件时携带的参数，即表单数据
      add_upData: function() {
        return {
          // body: JSON.stringify(this.form)
          name: this.form.name,
          softwareType: this.form.softwareType,
          version: this.form.version,
          memo: this.form.memo || '',
          type: this.form.type,
          cuttingFlag: this.cuttingFlag === true ? 1:0
        }
      },
      upgrade_upData: function() {
        return {
          // body: JSON.stringify(this.form)
          version: this.form.version,
          memo: this.form.memo,
          id: this.form.id,
          // type: this.form.type,
        }
      }
    },
    methods:{
      //表格数据
      firmwareTable(pageList){
        let data = {
          page: pageList,
          softwareType: this.search_softwareType,
          name: this.search_name,
          type: this.search_type
        }
        this.loading = true
        firmwareData(data).then(res=>{
          if(res.data.code == 0){
            this.tableData = res.data.data
            this.total = res.data.count
            this.tableData.forEach(item=>{
              if(item.type == 1){
                item.typeName = '网络类型'
              }else if(item.type == 2){
                item.typeName = '逻辑类型'
              }else if(item.type == 3){
                item.typeName = 'mesh类型'
              }else if(item.type == 4){
                item.typeName = '语音类型'
              }
            })
            console.log("firmwareData",this.tableData)
          }
          else{
            this.$message.warning(res.data.message)
          }
          this.loading = false
        }).catch(err=>{
          console.log(err);
          this.$message.warning(res.data.message)
          this.loading = false
        })
      },
      
      //时间戳转换时间
      timestampToTime (row, column) {
        var date = new Date(row.createTime) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
        var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' '
        var h = (date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':'
        var m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ':'
        var s = date.getSeconds() < 10 ? '0'+(date.getSeconds()) : date.getSeconds() 
        return Y+M+D+h+m+s
      },

      //文件状态改变时
      fileChange(file,fileList){
        console.log('文件状态改变时',file,fileList)
        this.fileUpload = true
        this.removeFile = false
        if (fileList.length > 0) {
          if(fileList[fileList.length - 1].response){
            if(fileList[fileList.length - 1].response.code == 0){
              this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的文件
            }
          }else{
            this.fileList = [fileList[fileList.length - 1]]
          }
        }
      },
      fileChange1(file,fileList){
        console.log('文件状态改变时',file,fileList)
        this.fileUpload1 = true
        this.removeFile1 = false
        if (fileList.length > 0) {
          if(fileList[fileList.length - 1].response){
            if(fileList[fileList.length - 1].response.code == 0){
              this.fileList1 = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的文件
            }
          }else{
            this.fileList1 = [fileList[fileList.length - 1]]
          }
        }
      },
      //crc算法
      crc32(str, crc) {
        var table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
        if( crc == window.undefined ) crc = 0;
          var n = 0; //a number between 0 and 255
          var x = 0; //an hex number
          crc = crc ^ (-1);
        for( var i = 0, iTop = str.length; i < iTop; i++ ) {
          n = ( crc ^ str.charCodeAt( i ) ) & 0xFF;
          x = "0x" + table.substr( n * 9, 8 );
          crc = ( crc >>> 8 ) ^ x;
        }
        // return crc ^ (-1);
        return (crc ^ (-1)) >>> 0;//解决值为负数的问题
      },
      buf2hex(buffer) {
        return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
      },
      hexCharCodeToStr(hexCharCodeStr) {
        var trimedStr = hexCharCodeStr.trim();
        var rawStr =
          trimedStr.substr(0, 2).toLowerCase() === "0x"
            ? trimedStr.substr(2)
            : trimedStr;
        var len = rawStr.length;
        if (len % 2 !== 0) {
          return "";
        }
        var curCharCode;
        var resultStr = [];
        for (var i = 0; i < len; i = i + 2) {
          curCharCode = parseInt(rawStr.substr(i, 2), 16);
          resultStr.push(String.fromCharCode(curCharCode));
        }
        return resultStr.join("");
      },
      //字符串转二进制
      strToBinary(str){
        var result = [];
        var list = str.split("");
        for(var i=0;i<list.length;i++){
            if(i != 0){
                result.push(" ");
            }
            var item = list[i];
            var binaryStr = item.charCodeAt().toString(2);
            result.push(binaryStr);
        }   
        return result.join("");
      },
      // return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).padStart(2, '0')).join('');
      // return Array.prototype.map
      // .call(buffer, (x) => ('00' + x.toString(16)).slice(-2))
      // .join('');
      // return Array.prototype.map.call(new Uint8Array(buffer), x => (
      //  x.toString(16)).slice(-2)).join('!');
      // return Array
      // .from (new Uint8Array (buffer))
      // .map (b => b.toString (16).padStart (2,"0"))
      // .join ("");
      // create a byte array (Uint8Array) that we can use to read the array buffer
      // const byteArray = new Uint8Array(buffer);
      // // for each element, we want to get its two-digit hexadecimal representation
      // const hexParts = [];
      // for(let i = 0; i < byteArray.length; i++) {
      //   // convert value to hexadecimal
      //   const hex = byteArray[i].toString(16);
      //   // pad with zeros to length 2
      //   const paddedHex = ('00' + hex).slice(-2);
      //   // push to array
      //   hexParts.push(paddedHex);
      // }
      // // join all the hex values of the elements into a single string
      // return hexParts.join('');
      // return Array.from(buffer, function(byte) {
      //   return ('0' + (byte & 0xFF).toString(16)).slice(-2);
      // }).join('')
      file_change(file,fileList){
        console.log('file_change',file,fileList)
      },
      file_change1(file,fileList){
        console.log('file_change1',file,fileList)
      },
      //移除文件
      handle_remove(file,fileList){
        console.log("handle_remove",file,fileList)
        this.fileList = []
      },
      handle_remove1(file,fileList){
        console.log("handle_remove1",file,fileList)
        this.fileList1 = []
      },
      //点击文件列表中已上传的文件时
      handlePreview(file){
        // console.log(file);
      },
      handlePreview1(file){
        // console.log(file);
      },
      upload_progress(event, file, fileList){
        console.log('upload_progress',event, file, fileList)
      },
      upload_progress1(event, file, fileList){
        console.log('upload_progress1',event, file, fileList)
      },
      //上传文件之前
      before_upload(file){
        console.log("before_upload",file);
        if(!this.cuttingFlag){
          console.log("version",this.form.version)
          if((this.form.softwareType == undefined || this.form.softwareType == '') || (this.form.version == undefined || this.form.version == '')){
            this.$message.warning("文件上传失败，请先填写型号和版本！")
            return false
          }
        }
        this.uploadLoading1 = this.$loading({
          lock: true,
          text: '文件上传中，请您耐心等候',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      before_upload1(file){
        console.log("before_upload1",file);
        if(this.firmwareId == this.form.id && this.version == this.form.version){
          this.$message.warning("版本号不能重复！")
          return false
        }
        if(!this.cuttingFlag){
          console.log("version",this.form.version)
          if((this.form.softwareType == undefined || this.form.softwareType == '') || (this.form.version == undefined || this.form.version == '')){
            this.$message.warning("文件上传失败，请先填写型号和版本！")
            return false
          }
        }
        this.uploadLoading2 = this.$loading({
          lock: true,
          text: '文件上传中，请您耐心等候',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      // 成功上传文件
      up_file(file){//获取文件的md5值和crc值
        if(this.uploadLoading1){
          this.uploadLoading1.close();
        }
        if(this.uploadLoading2){
          this.uploadLoading2.close();
        }
        const loading = this.$loading({
          lock: true,
          text: '文件数值正在加载中，请耐心等待',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.form.file = file.raw
        this.form.fileName = file.name//文件名
        this.form.fileSize = file.size//文件大小
        var  fileReader=new FileReader()
        var Spark=new SparkMD5.ArrayBuffer()
        fileReader.readAsArrayBuffer(file.raw)
        // console.log("",fileReader.readAsArrayBuffer(file.raw))
        let that = this
        fileReader.onload=function(e){
          Spark.append(e.target.result)
          console.log("e.target.result",e.target.result)
          
          var md5=Spark.end()
          console.log('md5',md5)
          that.MD5 = md5//文件md5 new Uint8Array([ 4, 8, 12, 16 ]).buffer

          // if(that.form.type == 1){
            if(that.fileVerificationMode == '2'){
            // this.form.fileMd5 = this.CRC32
            var file_result = e.target.result              // ArrayBuffer 数据对象
            var file_length = file_result.byteLength
            // 小于 20 MB 为小文件，则整个读取并上传
            // 大于 20 MB 为大文件，则需要将它切成小块，分别上传
            var step = 1024 * 1024 * 50
            that.CRC32 = ''
            let file_buf2hex
            if (file_length < step) {
                console.log("小文件，直接整个上传 ");
                // handleSmallFile(file_result)
                file_buf2hex = that.buf2hex(e.target.result)
                console.log("buf2hex",file_buf2hex)
                let str = that.hexCharCodeToStr(file_buf2hex)
                console.log("hexCharCodeToStr",str)
                that.CRC32 = that.crc32(str).toString(16)
                console.log("crc32", that.CRC32)
                let timer1 = setInterval(() => {
                  if(that.CRC32){
                    loading.close();
                    clearInterval(timer1)
                  }
                }, 2000);
            } else {
                var block_arr = that.splitBigFile(file_result, file_length, step)
                console.log("大文件，切块分别上传",block_arr);
                // file_buf2hex = that.buf2hex(block_arr)
                // that.handleBigFile(block_arr).then(function(results) {
                //     console.log("大文件，切块上传成功 result = ", results)
                // })
                let arr = []
                for(let i = 0; i < block_arr.length; i++){
                  // arr.push(that.buf2hex(block_arr[i]))
                  let ss = that.buf2hex(block_arr[i])
                  let str = that.hexCharCodeToStr(ss)
                  let crc32 = that.crc32(str).toString(16)
                  arr.push(crc32)//获取到分片文件的crc值，怎样合并成一个crc值
                }
                console.log("arr",arr)
                console.log('arr.join',arr.join(''))
                // that.CRC32 = arr.join('')
                that.CRC32 = arr[0]
                let timer2 = setInterval(() => {
                  if(that.CRC32){
                    loading.close();
                    clearInterval(timer2)
                  }
                }, 5000);
            }
          }else{
            // this.form.fileMd5 = this.MD5
            loading.close();
          }
          
          
          // let file_buf2hex = that.buf2hex(e.target.result)
          // let file_buf2hex = that.buf2hex(new Uint8Array(e.target.result).buffer)
          // console.log("buf2hex",file_buf2hex)
          // 计算当前分片的CRC值
          // var crcValue = 0xffffffff;
          // for (var k = 0; k < arr.length; ++k) {
          //     crcValue = arr[(crcValue ^ arr[k]) & 0xff] ^ (crcValue >>> 8);
          // }
          // console.log("crcValue",crcValue)
        }
      },
      // 根据指定的 step 大小，切出来指定的 step 大小的块
      splitBigFile(file, file_length, step) {
          var step_times = Math.ceil(file_length / step)
          var start = 0
          var block_arr = []

          for (let i = 0; i < step_times; i++) {
              var block = file.slice(start, start + step)
              start = start + step
              block_arr.push(block)
          }

          return block_arr
      },
      handleBigFile(big_files) {
          return Promise.all([].map.call(big_files, (file, index)=> {
              return new Promise((resolve, reject)=> {
                  // 先读取到 ArrayBuffer，再获取 ArrayBuffer 的 Uint8Array 字节数组形式，最后用 base64 编码字节数组用于传输。
                  // var view = new Uint8Array(file)             // 提取二进制字节数组，使用 Uint8Array 表示
                  // var base64_data = binary2base64(view)       // base64 编码
                  // console.log("==== handle upload start ====");
                  // console.log("block index = ", index);
                  // console.log("data = ", base64_data);
                  // console.log("==== handle upload end ====");
                  let file_buf2hex = this.buf2hex(file)
                  // // console.log("buf2hex",file_buf2hex)
                  // let str = this.hexCharCodeToStr(file_buf2hex)
                  // // console.log("hexCharCodeToStr",str)
                  // this.CRC32 = this.crc32(str).toString(16)
                  // console.log("crc32", this.CRC32) 
                  resolve(file_buf2hex)
                  
              })
          })).then(function(results) {
              return results;
          })
      },
      success_upFile(res,file,fileList){
        console.log("success_upFile",res,file,fileList)
        this.up_file(file)
        this.fileList = fileList
      },
      success_upFile1(res,file,fileList){
        console.log("success_upFile1",res,file,fileList)
        this.up_file(file)
        this.fileList1 = fileList
      },
      //2.自定义上传的回调里调用方法
      //注意这里需要写async，因为上传的方法用的async的语法糖
      async handle_file_custom(res){
        console.log("handle_file_custom",res,this.cuttingFlag)
        // let params = new FormData()
        // params.append('file', res.file) 
        // console.log("params",params)
        // let reader = new FileReader();
        // //读取文件流
        // reader.readAsArrayBuffer(res.file);
        // console.log("reader",reader,reader.result)
        // 上传新文件时，将进度条值置为零
        this.progressPercent = 0
        // 进度条
        const uploadProgressEvent = progressEvent => {
          progressPercent = Number((progressEvent.loaded * 100) / progressEvent.total)
          res.onProgress({progressPercent})
        }
        console.log('进度条',uploadProgressEvent,this.progressPercent)
        let file_path = this.form.softwareType+'/'+this.form.version+'/'//定义目录名
        let file_name = res.file.name
        let file = res.file
        let result = await upload_images_oss(file_path, file_name, file)//调用上传图片至oss的方法
        console.log("新增上传至oss",result)
      },
      async handle_file_custom1(res){
        console.log("handle_file_custom1",res)
        
        let file_path = this.form.softwareType+'/'+this.form.version+'/'//定义目录名
        let file_name = res.file.name
        let file = res.file
        let result = await upload_images_oss(file_path, file_name, file)//调用上传图片至oss的方法
        console.log("修改上传至oss",result)
      },
      //上传文件失败
      err_upFile(err,file){
        console.log("上传文件失败",err,file)
      },
      err_upFile1(err,file){
        console.log("升级文件失败",err,file)
        this.loading2.close();
      },
      //dailog确定
      confirmUploadBtn(formName){
        // this.loadingsubmit= true
        // this.confirmText = "提交中..."
        this.$refs[formName].validate((valid)=>{
          if(valid){
              let loading1 = null
              loading1 = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
              });
              this.form.filePath = this.form.softwareType+'/'+this.form.version+'/'//文件路径规则：固件类型/固件版本/，例如：P3161A/9/）
              this.form.cuttingFlag = this.cuttingFlag === true ? 1:0
              let time = 0
              // if(this.form.type == 1){
              if(this.fileVerificationMode == '2'){
                time = 1500
              }
              console.log("form表单",this.form);
              let params = new FormData()
              params.append('name', this.form.name) 
              params.append('softwareType', this.form.softwareType) 
              params.append('version', this.form.version) 
              params.append('id', this.form.id) 
              params.append('type', this.form.type) 
              params.append('cuttingFlag', this.form.cuttingFlag) 
              if(this.form.memo == undefined || this.form.memo == ""){
                // this.form.memo = "无"
                params.append('memo', "无") 
              }else{
                params.append('memo', this.form.memo) 
              }
              // console.log("params",params)
              // 表单验证通过后使用组件自带的方法触发上传事件
              //提交upload
              // this.$refs.upload.submit() 
              
              setTimeout(()=>{
                if(!this.cuttingFlag){
                  this.form.file = null
                }
                params.append('file', this.form.file) 
                params.append('fileName', this.form.fileName) 
                params.append('fileSize', this.form.fileSize) 
                params.append('filePath', this.form.filePath) 
                if(this.add){
                  if(this.fileList.length == 0 ){// || !this.fileUpload this.removeFile
                    this.$message.warning("文件未上传成功，请上传文件或等待上传")
                    this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                      loading1.close();
                    });
                  }else{
                    setTimeout(() => {
                      // if(this.form.type == 1){
                      if(this.fileVerificationMode == '2'){
                        this.form.fileMd5 = this.CRC32
                      }else{
                        this.form.fileMd5 = this.MD5
                      }
                      params.append('fileMd5', this.form.fileMd5) 
                      addFirmware(params).then(res=>{
                        console.log("新增固件",res)
                        if (res.data.code == 0) {
                          this.dialogFormVisible = false
                          // 文件上传成功后的回调，比如一些提示信息或者页面跳转都写在这里
                          this.$message.success("新增成功!");
                          this.firmwareTable(this.page)
                        } else {
                          this.$message.warning(res.message);
                          let _this = this;
                          setTimeout(function() {
                            _this.$refs.upload.clearFiles();
                          }, 1000);
                        }
                        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                          loading1.close();
                        });
                        this.fileUpload = false
                        this.fileList = []
                        this.cuttingFlag = false
                      }).catch(err=>{
                        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                          loading1.close();
                        });
                      })
                    }, time);
                  }
                }else{
                  if(this.fileList1.length == 0){// || !this.fileUpload1 || this.removeFile1
                    this.$message.warning("文件未上传成功，请上传文件或等待上传")
                    this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                      loading1.close();
                    });
                  }else{  
                    setTimeout(() => {
                      // if(this.form.type == 1){
                      if(this.fileVerificationMode == '2'){
                        this.form.fileMd5 = this.CRC32
                      }else{
                        this.form.fileMd5 = this.MD5
                      }
                      params.append('fileMd5', this.form.fileMd5) 
                      editFirmware(params).then(res=>{
                        console.log("修改固件",res)
                        if (res.data.code == 0) {
                          this.dialogFormVisible1 = false
                          // 文件上传成功后的回调，比如一些提示信息或者页面跳转都写在这里
                          this.$message.success("升级成功!");
                          this.firmwareTable(this.page)
                        } else {
                          this.$message.warning(res.message);
                          console.log(res.message)
                          let _this = this;
                          setTimeout(function() {
                            _this.$refs.upgrade_upload.clearFiles();
                          }, 1000);
                        }
                        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                          loading1.close();
                        });
                        this.fileUpload1 = false
                        this.fileList1 = []
                      }).catch(err=>{
                        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                          loading1.close();
                        });
                      })
                    }, time);
                  }
                }
              },500)
          }else{
            this.$message.error("表单验证不通过")
            // this.loadingsubmit = false
            // this.confirmText = "确定"
          }
        })  
      },
      //取消
      cancelUploadBtn(){
        this.dialogFormVisible = false
        this.dialogFormVisible1 = false
      },
      //新增
      addRecord(){
        this.dialogFormVisible = true
        this.add = true
        this.upgrade = false
        this.fileUpload = false
        this.dailogTitle = "新增记录"
        if (this.$refs['upgradeForm']!==undefined) {
          this.$refs['upgradeForm'].resetFields(); 
        }
        this.form = {}
        this.fileList = []
        // this.form.cuttingFlag =  0
        this.fileVerificationMode =  '1'
        this.cuttingFlag = false
      },
      //升级
      upgrade_firmware(row){
        // this.form = {...row}
        this.fileList1 = []
        this.$set(this.form, 'filePath', row.filePath)
        this.$set(this.form, 'name', row.name)
        this.$set(this.form, 'softwareType', row.softwareType)
        this.$set(this.form, 'version', Number(row.version))
        this.$set(this.form, 'memo', row.memo)
        this.$set(this.form, 'id', row.id)
        this.$set(this.form, 'type', row.type)
        this.$set(this.form, 'fileName', row.fileName)
        this.$set(this.form, 'fileSize', row.fileSize)
        this.$set(this.form, 'fileMd5', row.fileMd5)
        this.version = Number(row.version)
        this.firmwareId = row.id
        this.fileUpload1 = false
        this.dialogFormVisible1 = true
        this.add = false
        this.upgrade = true
        this.dailogTitle = "升级记录"
        this.form.file = null
        this.form.memo = row.memo
        if(row.cuttingFlag === 1){
          this.cuttingFlag = true
          // this.$set(this.form, 'cuttingFlag', true)
        }else{
          this.cuttingFlag = false
          // this.$set(this.form, 'cuttingFlag', false)
        }
        this.fileVerificationMode =  '1'
        console.log("升级需要的数据",row,this.form)
        // this.$refs['upgradeForm'].clearValidate(); 
      },
      //选择切割
      changeCheckbox(event){
        console.log("选择切割",event);
        if(event){
          
        }
      },
      //删除
      delRecord(row){
        let id = row.id
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            delFirmware(id).then(res=>{
            if(res.data.code == '0'){
              this.firmwareTable(this.page)
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          }).catch(err=>{
            this.$message({
              type: 'warning',
              message: '删除失败!'
            });
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
        
      },
      //切换页面
      changePage(e){
        this.page.pageNum = e
        this.firmwareTable(this.page)
      },
      changeSize(val){
        this.page.pageSize = val
        this.firmwareTable(this.page)
      },
    },
    mounted(){
      //表格数据
      this.firmwareTable(this.page)
      //文件地址
      // this.add_uploadUrl = process.env.NODE_ENV === "development" ? "http://192.168.20.245:8099/softwareVersion/add" : "https://config.pujie88.com/api/v2/softwareVersion/add"
      // this.upgrade_uploadUrl = process.env.NODE_ENV === "development" ? "http://192.168.20.245:8099/softwareVersion/update" : "https://config.pujie88.com/api/v2/softwareVersion/update"
      this.add_uploadUrl = process.env.NODE_ENV === "development" ? "https://config.pujie88.com/api/v2/softwareVersion/add" : "https://config.pujie88.com/api/v2/softwareVersion/add"
      this.upgrade_uploadUrl = process.env.NODE_ENV === "development" ? "https://config.pujie88.com/api/v2/softwareVersion/update" : "https://config.pujie88.com/api/v2/softwareVersion/update"
      // this.add_uploadUrl = process.env.NODE_ENV === "development" ? "/api1/softwareVersion/add" : "/api1/softwareVersion/add"
      // this.upgrade_uploadUrl = process.env.NODE_ENV === "development" ? "/api1/softwareVersion/update" : "/api1/softwareVersion/update"
      //get_sts().then(res=>{
        //console.log("get_sts",res)
      //})
      let er = this.strToBinary('14e3691a021ac178c8949e59d2e2ec78')
      console.log("er",er)
    }
  }
</script>

<style scoped>
a{
  text-decoration: none!important;
}
.softwareUpgrade{
    width: 100%;
    height: 100%;
}
.upgradeRecord{
    width: 20%;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    font-weight: 500px;
}
.upgrade{
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 10px 10px 0 0;
    justify-content: space-between;
}
.upgradeRecordTit{
    margin-left: 20px;
    font-size: 18px;
    font-weight: 600;
}
.upgrade_btn{
    background: #455AF7;
    color: #fff;
}
.upgradeBtn{
    margin-right: 20px;
}
.table{
  width: 100%;
  padding: 0 20px 20px 20px;
  box-sizing: border-box;
  background: #fff;
}
.table >>> .el-table td,
.table >>> .el-table th {
  text-align: center !important;
}
.table >>> th{
  background: #F2F3F7;
}
.uploadFile .el-input{
    width: 80%;
}
.uploadFile >>> .el-button{
  height: 40px;
}
.avatar_uploader{
  width: 100%;
}
.avatar_uploader >>> .el-upload{
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-icon-upload{
  font-size: 80px;
  margin: 10px 0;
}
/* 弹出框 */
.el-upload__text{
  height: 30px;
  line-height: 30px;
}
.avatar_uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar_uploader >>> .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 38px;
  color: #8c939d;
  /* width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center; */
}
.softwareUpgrade >>> .el-dialog{
  width: 40%;
  background:  #F2F3F7;
}
.softwareUpgrade >>> .el-dialog__header{
  display: flex;
  justify-content: center;
  font-weight: 500;
  background: #fff;
  font-size: 18px;
}
.softwareUpgrade >>> .el-dialog__body{
  padding: 15px 15px 0 15px!important;
}
.el-form{
  background: #fff;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.softwareUpgrade >>> .el-dialog__footer{
  padding: 0 15px 15px 15px!important;
}
.el-form-item{
  width: 85%;
}
.add_dialog >>> .el-select{
  width: 100%;
}
.uploadFile >>> .el-form-item__content{
  margin-left: 80px;
  line-height: 0px;
}
.dialog-footer{
  background: #fff;
  padding: 10px ;
}
.avatar_uploader >>> .el-upload-dragger{
  width: 100%;
  height: 100%;
}
.pagination {
  width: 100%;
  height: 80px;
  background: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 20px;
  box-sizing: border-box;
}
.pagination >>> .el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #455AF7!important;
}
.delete{
  color: #FB3F4E!important;
}
.upgrade_btn1{
  color: #455AF7!important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home/firmwareUpdate/index.vue